import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e9981c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "original_main_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tabTitle" }, "Links", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "conectados hoy", -1))
const _hoisted_4 = {
  key: 0,
  class: "out_loader"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick", "disabled"]
const _hoisted_9 = { class: "text_to_copy" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text_copiado" }, [
  /*#__PURE__*/_createTextVNode("¡Link "),
  /*#__PURE__*/_createElementVNode("span", null, "Copiado"),
  /*#__PURE__*/_createTextVNode("!")
], -1))
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = { class: "text_to_copy" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text_copiado" }, [
  /*#__PURE__*/_createTextVNode("¡Link "),
  /*#__PURE__*/_createElementVNode("span", null, "Copiado"),
  /*#__PURE__*/_createTextVNode("!")
], -1))
const _hoisted_14 = { class: "left_div_link" }
const _hoisted_15 = ["id"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "conectados", -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  fill: "outline",
  class: "play_button_link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headertoolbar = _resolveComponent("headertoolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "headerTop ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_headertoolbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.swipeToRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_header, { collapse: "condense" }),
            _createVNode(_component_ion_icon, {
              class: "l_close_a",
              button: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push('/tabs/tabReproductor'))),
              src: "assets/ICONOS/close.svg"
            }),
            _hoisted_2,
            _createVNode(_component_ion_text, { class: "title_links" }, {
              default: _withCtx(() => [
                _createElementVNode("h1", {
                  class: _normalizeClass(["dot_cargando", { 'dot_yellow': _ctx.conectadosTotal == 0 && _ctx.isLoading == false, 'dot_green': _ctx.conectadosTotal >= 0 && _ctx.isLoading == false }])
                }, _toDisplayString(_ctx.conectadosTotal >= 0 ? _ctx.conectadosTotal : 0), 3),
                _hoisted_3
              ]),
              _: 1
            }),
            (_ctx.linksReq.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : (_openBlock(), _createBlock(_component_ion_list, {
                  key: 1,
                  lines: "inset",
                  class: "link_items"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linksReq, (link) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "none",
                        class: _normalizeClass(["link_item", { 'selected': _ctx.clientlink == link.link }]),
                        key: link.id
                      }, {
                        default: _withCtx(() => [
                          (link.mobileimage)
                            ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                key: 0,
                                slot: "start",
                                class: "link_image",
                                style: _normalizeStyle('background-image:url(https://pub-3b7d9c13a5754ebeaa0345eb87aa22c1.r2.dev/images/' + link.mobileimage + '); background-color:#' + link.color + '')
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"opacity":"0"},
                                    src: 'https://pub-3b7d9c13a5754ebeaa0345eb87aa22c1.r2.dev/images/' + link.mobileimage
                                  }, null, 8, _hoisted_7)
                                ]),
                                _: 2
                              }, 1032, ["style"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_label, { placeholder: "copiar link" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(link.name), 1),
                              (_ctx.clientData.sonara)
                                ? (_openBlock(), _createBlock(_component_CopyToClipboard, { key: 0 }, {
                                    default: _withCtx((props) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["copy_link", props.status]),
                                        onClick: ($event: any) => (props.copy('https://sonara.red/' + link.link)),
                                        disabled: props.status === 'copied'
                                      }, [
                                        _createVNode(_component_ion_icon, {
                                          class: "icon_l",
                                          slot: "start",
                                          src: "assets/ICONOS/links-gris.svg"
                                        }),
                                        _createElementVNode("strong", _hoisted_9, [
                                          _createTextVNode("sonara.red"),
                                          _createElementVNode("span", null, "/" + _toDisplayString(link.link), 1)
                                        ]),
                                        _hoisted_10
                                      ], 10, _hoisted_8)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_CopyToClipboard, { key: 1 }, {
                                    default: _withCtx((props) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["copy_link", props.status]),
                                        onClick: ($event: any) => (props.copy('https://app.vybroo.net/' + link.link)),
                                        disabled: props.status === 'copied'
                                      }, [
                                        _createVNode(_component_ion_icon, {
                                          class: "icon_l",
                                          slot: "start",
                                          src: "assets/ICONOS/links-gris.svg"
                                        }),
                                        _createElementVNode("strong", _hoisted_12, [
                                          _createTextVNode("app.vybroo.net"),
                                          _createElementVNode("span", null, "/" + _toDisplayString(link.link), 1)
                                        ]),
                                        _hoisted_13
                                      ], 10, _hoisted_11)
                                    ]),
                                    _: 2
                                  }, 1024))
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_ion_grid, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, { class: "c_conectados" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", {
                                          id: 'dot_' + link.stream,
                                          class: _normalizeClass(["dot_cargando", { 'dot_yellow': _ctx.conectados[link.stream] == 0 && _ctx.isLoading == false, 'dot_green': _ctx.conectados[link.stream] >= 0 && _ctx.isLoading == false }])
                                        }, _toDisplayString(_ctx.conectados[link.stream] ? _ctx.conectados[link.stream] : 0), 11, _hoisted_15),
                                        _hoisted_16
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, { class: "play_icon_conectados" }, {
                                      default: _withCtx(() => [
                                        (link.link != _ctx.currentLink)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              fill: "outline",
                                              class: "play_button_link",
                                              onClick: ($event: any) => (_ctx.confirmarCambioLink(link.link))
                                            }, [
                                              _createVNode(_component_ion_icon, {
                                                class: "unselectedLink",
                                                slot: "start",
                                                src: "assets/ICONOS/reproductor-blanco.svg"
                                              })
                                            ], 8, _hoisted_17))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                              _createVNode(_component_ion_icon, {
                                                class: "selectedLink",
                                                slot: "start",
                                                src: "assets/ICONOS/reproductor-blanco.svg"
                                              })
                                            ]))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                }))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}